import { Component, OnInit } from '@angular/core';
import config from '../../../frontend_config.json';

import {LanguageService} from '../language/language.service';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  title = 'Pronotes';
  config = config;

  reviews = [
    {
      review: 'Lorem ipsum cos tam cos tam muspi meroL',
      who: 'who'
    },
    {
      review: 'Lorem ipsum cos tam cos tam muspi meroL',
      who: 'who'
    },
    {
      review: 'Lorem ipsum cos tam cos tam muspi meroL',
      who: 'who'
    },
    {
      review: 'Lorem ipsum cos tam cos tam muspi meroL',
      who: 'who'
    }
  ]

/*
  constructor(public languageService: LanguageService) { }

  ngOnInit(): void {
  }
 */
  constructor(
    private meta: Meta,
    private titleService: Title,
    public languageService: LanguageService
  ) {}

  ngOnInit() {
    // 1. Pobieramy dynamicznie tytuł i opis z sekcji 'seo' Twojego JSONa
    const seoTitle = this.languageService.getLang('home title', 'seo');
    const seoDesc = this.languageService.getLang('home desc', 'seo');

    // 2. Ustawiamy tytuł karty w przeglądarce
    this.titleService.setTitle(seoTitle);

    // 3. Używamy updateTag, aby uniknąć duplikatów i wspierać zmianę języka
    this.meta.updateTag({ name: 'description', content: seoDesc });

    // 4. Roboty (keywords usuwamy, bo Google ich nie czyta, a tylko zaśmiecają kod)
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });
  }

}
